@if (getViaListLength) {
  <div (click)="routeNavigation()" (keyup.enter)="routeNavigation()" tabindex="0" class="navigate-div" title='Opens in a new window'>
    <button class="btn btn-navigate">
      <span></span>
    </button>
    <span class="navigate-text">
      Navigate
    </span>
  </div>
}